import { useFirebase } from '../../../hooks/useFirebase';

import { queryFileUpload } from '../../tools/tools';
import { useMutation } from '@tanstack/react-query';

export const useImageUpload = (endpoint, accessToken) => {
  const { remoteConfig } = useFirebase();

  const {
    mutate: upload,
    isLoading: loading,
    isError: error,
    reset
  } = useMutation({
    mutationFn: async (file) => {
      if (!(file instanceof File)) throw new Error('Invalid file');
      return await queryFileUpload(remoteConfig, endpoint, file, accessToken);
    }
  });

  return {
    upload,
    loading,
    error,
    reset
  };
};
